export const ROLE_SUPER_ADMIN = "super_admin"
export const SUPER_ADMIN_WRITE = "super_admin_write"